import styled, { css } from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  > span {
    display: none;
  }

    &:before {
      content: '';
      height: 2px;
      width: 18px;
      background: ${props => props.theme.cores.cinza200};      
      ${props => ( props.active || props.completed ) && css`
        background: ${props.theme.cores.azul};
      `}
    }
    &:first-child:before {
      display: none;
    }

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) {   
    opacity: ${props => !props.active && !props.completed && css`0.6`};
    margin-left: 50px;
    > span {
      display: block;
    }

    &:before {
      display:none
    }

    
  }

`

export { Container }
